// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/check-white.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/images/myAccount/invoice-fold-right-top.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff");
}
@font-face {
  font-family: "Inter", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff");
}
@font-face {
  font-family: "Source Sans Pro", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff");
}
.SelectPaymentBlock_selectPaymentBlock__ZF58i {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 40px;
  font-family: "Inter", sans-serif;
}

/* Agreement block */
.SelectPaymentBlock_agreement__Su556 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-radius: 8px;
  background-color: #fff;
  position: relative;
}

/* LEFT: service info + checkbox */
.SelectPaymentBlock_agreementHeader__NKg3s {
  flex: 1 1 70%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 20px;
  border: 1px solid;
  background-color: #f5f5f5;
}

.SelectPaymentBlock_agreementCheckbox__hMN4O {
  width: 18px;
  height: 18px;
  cursor: pointer;
  padding: 10px;
}

.SelectPaymentBlock_salesAgrNum__mvyf5 {
  font-size: 14px;
  font-weight: 600;
  color: #414141;
}

.SelectPaymentBlock_serviceLabel__AVYOq {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #222222;
  font-family: "Inter", sans-serif;
}

/* RIGHT: pricing + tooltip */
.SelectPaymentBlock_agreementDetails__0Tpt\\+ {
  flex: 1 1 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 20px;
  position: relative;
  border: 1px solid;
}

.SelectPaymentBlock_amountRow__7ulMr {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.SelectPaymentBlock_payNowLabel__XOdjO {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  padding-top: 10px;
}

.SelectPaymentBlock_agrAmount__dqQLd {
  font-size: 16px;
  color: #8a94a6;
  text-decoration: line-through;
  font-family: "Inter", sans-serif;
}
.SelectPaymentBlock_agrAmount__dqQLd sup {
  font-size: 11px;
  vertical-align: top;
  margin-left: 1px;
}

.SelectPaymentBlock_totalAmount__SrJN6 {
  font-size: 28px;
  font-weight: 700;
  color: #39d25a;
}
.SelectPaymentBlock_totalAmount__SrJN6 sup {
  font-size: 14px;
  vertical-align: top;
  margin-left: 4px;
}

/* Responsive */
@media screen and (max-width: 767px) {
  .SelectPaymentBlock_agreement__Su556 {
    flex-direction: column;
    padding: 16px;
  }
  .SelectPaymentBlock_agreementHeader__NKg3s,
  .SelectPaymentBlock_agreementDetails__0Tpt\\+ {
    flex: 1 1 100%;
    border-right: none;
  }
  .SelectPaymentBlock_agreementDetails__0Tpt\\+ {
    margin-top: 12px;
    border-top: 1px solid #e4e6eb;
  }
  .SelectPaymentBlock_tooltipRow__LHI-V {
    left: auto;
    right: 12px;
    top: 12px;
    transform: none;
  }
  .SelectPaymentBlock_tooltipText__\\+XKyY {
    width: 300px;
    left: 0%;
  }
  .SelectPaymentBlock_totalAmount__SrJN6 {
    font-size: 32px;
    line-height: 36.8px;
  }
}
.SelectPaymentBlock_tooltipContainer__oYFEM {
  position: absolute;
  top: 50%;
  right: -20px;
  /* push outside border */
  transform: translateY(-50%);
}

/* Badge */
.SelectPaymentBlock_tooltipBadge__0tsNZ {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #f4a100;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Popup */
.SelectPaymentBlock_tooltipText__\\+XKyY {
  display: none;
  position: absolute;
  left: 40px;
  top: 50%;
  transform: translateY(-50%);
  background: #080808;
  box-shadow: 0px 7px 7px rgba(0, 0, 0, 0.09), 0px 2px 4px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.1), 0px 0px 24px rgba(0, 0, 0, 0.16);
  padding: 12px 16px;
  border-radius: 8px;
  width: 280px;
  font-size: 14px;
  line-height: 18px;
  color: #f7f3f3;
  z-index: 10;
}

.SelectPaymentBlock_tooltipText__\\+XKyY::after {
  content: "";
  position: absolute;
  top: 50%;
  left: -6px;
  transform: translateY(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: transparent #fff transparent transparent;
}

.SelectPaymentBlock_tooltipBadge__0tsNZ:hover + .SelectPaymentBlock_tooltipText__\\+XKyY {
  display: block;
}

.SelectPaymentBlock_paymentSummaryBox__tBoe1 {
  background-color: #414141;
  color: #ffffff;
  padding: 24px;
  max-width: 240px;
  margin-left: auto;
}
.SelectPaymentBlock_paymentSummaryBox__tBoe1 p {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 0.6;
}
.SelectPaymentBlock_paymentSummaryBox__tBoe1 p:first-of-type {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
}
.SelectPaymentBlock_paymentSummaryBox__tBoe1 span {
  display: block;
  margin-top: 12px;
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
}
.SelectPaymentBlock_paymentSummaryBox__tBoe1 .SelectPaymentBlock_savings__HkL5T {
  margin-top: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #00c853;
}

@media (min-width: 768px) {
  .SelectPaymentBlock_mb-md-0__B9c1I {
    margin-bottom: 0 !important;
  }
  .SelectPaymentBlock_p-10__NP6j5 {
    padding: 10px !important;
  }
}
.SelectPaymentBlock_mb-20__jLCRP {
  margin-bottom: 20px !important;
}

.SelectPaymentBlock_border-bottom__sGzHR {
  border-bottom: 1px solid #6c757d !important;
}

.SelectPaymentBlock_p-30__GELuM {
  padding: 30px !important;
}

.SelectPaymentBlock_g-font-weight-300__hSmoK, .SelectPaymentBlock_gfw-3__bPgkf {
  font-weight: 300 !important;
}

@media (min-width: 768px) {
  .SelectPaymentBlock_text-md-left__IiorS {
    text-align: left !important;
  }
}
.SelectPaymentBlock_g-font-size-24__VUBuK, .SelectPaymentBlock_gfs-24__jddBf {
  font-size: 24px !important;
}

.SelectPaymentBlock_gfs-md-22__YSg9T {
  font-size: 22px;
}

.SelectPaymentBlock_g-line-height-1__rElOa, .SelectPaymentBlock_glh-1__6lHT- {
  line-height: 1 !important;
}

.SelectPaymentBlock_tru-mma-main-add__PhxiX, .SelectPaymentBlock_tru-mma-main-content-box__3k3Rb, .SelectPaymentBlock_tru-mma-main-service-box__t0W-B, .SelectPaymentBlock_tru-mma-main-wrapper__ii\\+D- {
  border: 1px solid #6c757d !important;
}

@media (min-width: 768px) {
  .SelectPaymentBlock_mma-wrapper__ujeDz .SelectPaymentBlock_tru-mma-main-wrapper__ii\\+D- .SelectPaymentBlock_tru-mma-main-content-box__3k3Rb .SelectPaymentBlock_tru-mma-main-side__xGOTL {
    border-left: 1px solid #6c757d !important;
  }
  .SelectPaymentBlock_tru-mma-main-side__xGOTL {
    border-left: 1px solid #6c757d;
  }
}
@media (min-width: 992px) {
  .SelectPaymentBlock_text-lg-left__\\+M20N {
    text-align: left !important;
  }
}
.SelectPaymentBlock_bg-white__Rzm1e {
  background-color: #fff !important;
}

@media (min-width: 992px) {
  .SelectPaymentBlock_col-lg-3__AINdq {
    flex: 0 0 25%;
    max-width: 25%;
  }
}
@media (min-width: 768px) {
  .SelectPaymentBlock_col-md-4__Bag5B {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
}
@media (min-width: 992px) {
  .SelectPaymentBlock_g-font-size-lg-16__KLRa0, .SelectPaymentBlock_gfs-lg-16__-fagT {
    font-size: 16px !important;
  }
}
@media (min-width: 992px) {
  .SelectPaymentBlock_text-lg-left__\\+M20N {
    text-align: left !important;
  }
}
.SelectPaymentBlock_g-text-strike__OGu5l {
  text-decoration: line-through;
}

@media (min-width: 768px) {
  .SelectPaymentBlock_g-font-size-md-40__QZJT6, .SelectPaymentBlock_gfs-md-40__16L33 {
    font-size: 40px !important;
  }
}
@media (max-width: 767px) {
  .SelectPaymentBlock_text-green__MLL9P {
    font-size: 50px !important;
    font-weight: 700 !important;
  }
  .SelectPaymentBlock_text-green__MLL9P sup {
    font-size: 26px;
  }
  .SelectPaymentBlock_tru-mma-main-content-box__3k3Rb {
    border: 0 !important;
  }
  .SelectPaymentBlock_service-tooltip__ydzhE {
    right: 0 !important;
  }
}
.SelectPaymentBlock_g-font-weight-700__qQ3Fh, .SelectPaymentBlock_gfw-7__wnUix {
  font-weight: 700 !important;
}

.SelectPaymentBlock_g-line-height-1_2__Ul3mQ, .SelectPaymentBlock_glh-1_2__PpsYt {
  line-height: 1.2 !important;
}

.SelectPaymentBlock_text-green__MLL9P {
  color: #73c573 !important;
}

.SelectPaymentBlock_g-font-weight-300__hSmoK, .SelectPaymentBlock_gfw-3__bPgkf {
  font-weight: 300 !important;
}

.SelectPaymentBlock_g-line-height-1_2__Ul3mQ, .SelectPaymentBlock_glh-1_2__PpsYt {
  line-height: 1.2 !important;
}

.SelectPaymentBlock_g-font-size-14__-18y9, .SelectPaymentBlock_gfs-14__evAbY {
  font-size: 14px !important;
}

@media only screen and (min-width: 768px) {
  .SelectPaymentBlock_mma-wrapper__ujeDz .SelectPaymentBlock_tru-mma-main-side__xGOTL .SelectPaymentBlock_service-tooltip__ydzhE {
    right: -18px;
  }
}
@media only screen and (min-width: 768px) {
  .SelectPaymentBlock_mma-wrapper__ujeDz .SelectPaymentBlock_service-tooltip__ydzhE {
    right: -50px;
  }
}
@media (min-width: 768px) {
  .SelectPaymentBlock_mma-wrapper__ujeDz .SelectPaymentBlock_service-tooltip__ydzhE {
    right: -2px;
    width: 40px;
    height: 40px;
    line-height: 40px;
  }
}
.SelectPaymentBlock_mma-wrapper__ujeDz .SelectPaymentBlock_service-tooltip__ydzhE {
  top: 0;
  right: -11px;
  bottom: 0;
  width: 30px;
  height: 30px;
  margin: auto;
  box-shadow: -2px 2px 0 0 hsla(0, 0%, 84.7%, 0.74902);
  cursor: pointer;
  line-height: 30px;
}

@media (min-width: 768px) {
  .SelectPaymentBlock_g-font-size-md-32__7Ixdk, .SelectPaymentBlock_gfs-md-32__s5WO9 {
    font-size: 32px !important;
  }
}
.SelectPaymentBlock_g-font-size-24__VUBuK, .SelectPaymentBlock_gfs-24__jddBf {
  font-size: 24px !important;
}

.SelectPaymentBlock_g-font-weight-700__qQ3Fh, .SelectPaymentBlock_gfw-7__wnUix {
  font-weight: 700 !important;
}

.SelectPaymentBlock_text-white__wRJU5 {
  color: #fff !important;
}

.SelectPaymentBlock_text-center__QdNHm {
  text-align: center !important;
}

.SelectPaymentBlock_position-absolute__fkx5F {
  position: absolute !important;
}

.SelectPaymentBlock_d-block__7dxmq {
  display: block !important;
}

.SelectPaymentBlock_bg-secondary__n7utl {
  background-color: #ffb034 !important;
}

@media (min-width: 768px) {
  .SelectPaymentBlock_g-font-size-md-32__7Ixdk, .SelectPaymentBlock_gfs-md-32__s5WO9 {
    font-size: 32px !important;
  }
}
.SelectPaymentBlock_g-font-size-24__VUBuK, .SelectPaymentBlock_gfs-24__jddBf {
  font-size: 24px !important;
}

.SelectPaymentBlock_g-font-weight-700__qQ3Fh, .SelectPaymentBlock_gfw-7__wnUix {
  font-weight: 700 !important;
}

.SelectPaymentBlock_text-white__wRJU5 {
  color: #fff !important;
}

.SelectPaymentBlock_text-center__QdNHm {
  text-align: center !important;
}

.SelectPaymentBlock_position-absolute__fkx5F {
  position: absolute !important;
}

.SelectPaymentBlock_d-block__7dxmq {
  display: block !important;
}

.SelectPaymentBlock_bg-secondary__n7utl {
  background-color: #ffb034 !important;
}

.SelectPaymentBlock_tooltipReg__B0gpi {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
  width: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
  right: -40px !important;
}

.SelectPaymentBlock_service-tooltip__ydzhE {
  top: 0;
  right: -40px;
  bottom: 0;
  width: 40px;
  height: 40px;
  margin: auto;
  box-shadow: -2px 2px 0 0 hsla(0, 0%, 84.7%, 0.74902);
  cursor: pointer;
  line-height: 40px;
  background: #FFB034;
  font-size: 32px !important;
  font-weight: 700 !important;
  text-decoration: none;
}

.SelectPaymentBlock_service-tooltip__ydzhE:after {
  position: absolute;
  right: 0;
  bottom: -10px;
  width: 0;
  height: 0;
  border-color: #a95f1e transparent transparent;
  border-style: solid;
  border-width: 10px 10px 0 0;
  content: "";
}

input[type=checkbox]:checked {
  border-radius: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: #666 !important;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 60%;
}

.SelectPaymentBlock_select-all-check__pcVeJ, .SelectPaymentBlock_select-all-radio__BGQcv {
  height: 25px !important;
  min-height: 0 !important;
  width: 25px !important;
}

.SelectPaymentBlock_mr-10__CH9tc {
  margin-right: 10px !important;
}

.SelectPaymentBlock_mb-20__jLCRP {
  margin-bottom: 20px !important;
}

@media (min-width: 768px) {
  .SelectPaymentBlock_mb-md-0__B9c1I {
    margin-bottom: 0 !important;
  }
}
.SelectPaymentBlock_img-fluid__xTLb4 {
  width: 24px;
  height: 24px;
}

.SelectPaymentBlock_gfs-20__ZtoTg {
  font-size: 20px !important;
}

@media (min-width: 768px) {
  .SelectPaymentBlock_text-md-left__IiorS {
    text-align: left !important;
  }
}
.SelectPaymentBlock_clr-amt__38T1V {
  color: #303236;
}

.SelectPaymentBlock_text-white__wRJU5 {
  color: #fff !important;
}

@media (min-width: 992px) {
  .SelectPaymentBlock_g-font-size-lg-16__KLRa0, .SelectPaymentBlock_gfs-lg-16__-fagT {
    font-size: 16px !important;
    font-weight: 300;
    line-height: 1.2;
  }
}
.SelectPaymentBlock_g-font-weight-300__hSmoK, .SelectPaymentBlock_gfw-3__bPgkf {
  font-weight: 300 !important;
}

.SelectPaymentBlock_g-line-height-1_2__Ul3mQ, .SelectPaymentBlock_glh-1_2__PpsYt {
  line-height: 1.2 !important;
}

@media (min-width: 768px) {
  .SelectPaymentBlock_mt-md-10__xSiLD {
    margin-top: 10px !important;
  }
}
.SelectPaymentBlock_text-grey__oHScB {
  color: #666666;
}

.SelectPaymentBlock_one-time-open-invoice__dOGmC {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 200px;
  height: auto;
  width: 100%;
}
.SelectPaymentBlock_one-time-open-invoice__dOGmC h3 {
  font-family: "DM Sans", sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  color: #303236;
  margin-bottom: 0;
}

.SelectPaymentBlock_one-time-subtext__okOL1 {
  margin-top: -5px;
  margin-bottom: 0;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #6c757d;
}

.SelectPaymentBlock_one-time-invoice-container__QGL3\\+ {
  display: flex;
  gap: 0 20px;
  flex-wrap: wrap;
}

.SelectPaymentBlock_one-time-invoice-box__YaMHH {
  display: flex;
  border: 1px solid #c6c6c6;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 20px;
  flex: 0 1 48%;
}
@media only screen and (max-width: 767px) {
  .SelectPaymentBlock_one-time-invoice-box__YaMHH {
    flex: 0 1 100%;
  }
}

.SelectPaymentBlock_one-time-invoice-box-content__YJryY {
  width: 100%;
}

.SelectPaymentBlock_one-time-form-check-label__EJGmt span {
  font-weight: 500;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #303236;
  margin-left: 0;
}

.SelectPaymentBlock_one-time-checkmark__q9NTO {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #303236;
  border-radius: 3px;
  margin-top: 3px;
  border-color: #d2d6de;
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

.SelectPaymentBlock_one-time-checkmark__q9NTO:focus {
  box-shadow: none;
  border-color: #d2d6de;
}

.SelectPaymentBlock_one-time-checkmark__q9NTO:checked {
  background-color: #666;
  border-color: #666;
}

.SelectPaymentBlock_one-time-due-amount__rHAS2 {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: hsl(220, 6%, 20%);
  margin: 0 0 0px 38px;
}
.SelectPaymentBlock_one-time-due-amount__rHAS2 span {
  font-weight: 700;
}

.SelectPaymentBlock_one-time-due-date__YbiXc {
  justify-content: space-between;
  margin-bottom: 8px;
}

.SelectPaymentBlock_one-time-see-more__AQZhL {
  text-align: end;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #73c573;
  text-decoration: underline;
}

.SelectPaymentBlock_one-time-invoice-link-row__pDl8r {
  margin-left: 28px;
}

.SelectPaymentBlock_one-time-view-invoice__mn1FS {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #303236;
  text-decoration: underline;
}

.SelectPaymentBlock_one-time-modal-lines__iDt1o {
  padding-bottom: 30px;
}

.SelectPaymentBlock_bg-dark-pay-now__DjsIo {
  background: #414141 !important;
  padding: 10px !important;
}

.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR {
  max-width: 900px;
  margin: 28px auto;
}
@media (max-width: 767px) {
  .SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR {
    margin: 0 5px;
  }
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_modal-content-invoice__Yv\\+5T {
  color: #00703c;
  border-radius: 0;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_left-white__s26lN {
  flex: 0 0 83.33333%;
  max-width: 83.33333%;
}
@media (max-width: 767px) {
  .SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_left-white__s26lN {
    max-width: 58.3333%;
    flex: 0 0 58.3333%;
  }
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_left-white__s26lN p {
  font-size: 1em;
  font-weight: 400;
  margin-top: 30px;
  margin-left: 30px;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_fold__VI\\+Oi {
  height: 100px;
  width: 100px;
  background: #999 url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  background-position: 100% 0;
  flex: 0 0 16.66667%;
  max-width: 16.66667%;
  min-width: 75px;
  padding: 0px;
}
@media (max-width: 767px) {
  .SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_fold__VI\\+Oi {
    max-width: 37.6667%;
    flex: 0 0 36.5%;
  }
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_fold__VI\\+Oi .SelectPaymentBlock_ntrclose-button__cS3KZ {
  width: 60px;
  height: 60px;
  padding-top: 18px;
  line-height: 0;
  padding-left: 18px;
  color: #000000;
  text-align: center;
  float: right;
  text-decoration: none;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_fold__VI\\+Oi .SelectPaymentBlock_ntrclose-button__cS3KZ span {
  font-size: 60px;
  font-weight: 700;
  color: #ffffff;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_wrapper-invoice__cnlfW {
  width: 100%;
  padding-right: 12px;
  padding-left: 12px;
  margin-right: auto;
  margin-left: auto;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU {
  background: #ffffff;
  padding: 30px;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e {
  color: #666666;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  margin-bottom: 30px;
}
@media (max-width: 767px) {
  .SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n {
    flex-wrap: wrap;
  }
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_addr__7Fx3B {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  font-weight: 300;
  font-size: 24px;
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
}
@media (max-width: 767px) {
  .SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_addr__7Fx3B {
    max-width: 100%;
    flex: 0 0 100%;
    text-align: center;
  }
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_addr__7Fx3B .SelectPaymentBlock_name__C7BV8 {
  font-size: 1em;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_addr__7Fx3B .SelectPaymentBlock_cust-number__gkFL\\+ {
  font-size: 0.5em;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_invoice-amount__FHeSW {
  height: 116px;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  text-align: center;
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
}
@media (max-width: 767px) {
  .SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_invoice-amount__FHeSW {
    max-width: 100%;
    flex: 0 0 100%;
    text-align: center;
  }
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_invoice-amount__FHeSW .SelectPaymentBlock_amount-title__jLEQ9 {
  font-size: 1.5em;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_invoice-amount__FHeSW .SelectPaymentBlock_amount__Fc-1S {
  color: #70c66f;
  font-weight: 700;
  font-size: 3em;
  margin-top: 0;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_invoice-amount__FHeSW .SelectPaymentBlock_amount__Fc-1S .SelectPaymentBlock_tg-ml-11__YFy4r {
  top: -10px;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_invoice-status__OST-P {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
}
@media (max-width: 767px) {
  .SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_invoice-status__OST-P {
    max-width: 100%;
    flex: 0 0 100%;
    text-align: center;
    margin-top: 30px;
  }
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_invoice-status__OST-P .SelectPaymentBlock_invoice-status-paid__ZFC3I {
  height: 116px;
  padding-top: 30px;
  background: #70c66f;
  text-align: center;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_invoice-status__OST-P .SelectPaymentBlock_invoice-status-paid__ZFC3I h2 {
  color: #ffffff;
  padding: 0;
  margin: 0;
  font-size: 44px;
  font-weight: 900;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_main__yxp2n .SelectPaymentBlock_invoice-status__OST-P .SelectPaymentBlock_invoice-status-paid__ZFC3I p {
  color: #ffffff;
  font-weight: 400;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_service__J7wMS {
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 30px;
  border: 1px solid #9e9e9e;
  background: #FAFAFA;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_service__J7wMS .SelectPaymentBlock_service-title__\\+frvN {
  color: #000000;
  font-weight: 400;
  font-size: 1.2em;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_service__J7wMS .SelectPaymentBlock_service-date__60W-x {
  color: #70c66f;
  font-size: 1em;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_service__J7wMS .SelectPaymentBlock_service-table-wrapper__fBj2u {
  overflow-x: auto;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_service__J7wMS .SelectPaymentBlock_service-table__kctWv {
  width: 100%;
  border-collapse: collapse;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_service__J7wMS .SelectPaymentBlock_service-table__kctWv th, .SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_service__J7wMS .SelectPaymentBlock_service-table__kctWv td {
  padding: 10px 12px;
  text-align: left;
  white-space: nowrap;
  border-bottom: 1px solid #9e9e9e;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_service__J7wMS .SelectPaymentBlock_service-table__kctWv th {
  color: #000000;
  font-weight: 700;
  font-size: 0.9em;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_service__J7wMS .SelectPaymentBlock_service-table__kctWv .SelectPaymentBlock_service-title__\\+frvN {
  font-size: 1em;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_service__J7wMS .SelectPaymentBlock_service-table__kctWv .SelectPaymentBlock_view-invoice-ticket__YNaS\\+ {
  white-space: nowrap;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_view-pint-btn__pLt2v .SelectPaymentBlock_view-invoice-ticket__YNaS\\+ {
  background: #FFB034;
  color: #ffffff;
  border-radius: 0;
  line-height: 1.3;
  font-size: 18px;
  font-weight: 700;
  padding: 8px 18px;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_view-pint-btn__pLt2v .SelectPaymentBlock_view-invoice-ticket__YNaS\\+:hover {
  text-decoration: underline;
}
@media (max-width: 767px) {
  .SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_view-pint-btn__pLt2v .SelectPaymentBlock_view-invoice-ticket__YNaS\\+ {
    flex-direction: column;
    max-width: 100%;
    flex: 0 0 100%;
    text-align: center;
    gap: 30px;
    width: 100%;
  }
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_view-pint-btn__pLt2v .SelectPaymentBlock_print-invoice__KHHST {
  background: #999999;
  color: #ffffff;
  border-radius: 0;
  line-height: 1.3;
  font-size: 18px;
  font-weight: 700;
  padding: 8px 18px;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_view-pint-btn__pLt2v .SelectPaymentBlock_print-invoice__KHHST:hover {
  text-decoration: underline;
}
@media (max-width: 767px) {
  .SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_modal-dialog-invoice__kRimR .SelectPaymentBlock_white-wrapper__THbhU .SelectPaymentBlock_bg-white__Rzm1e .SelectPaymentBlock_wrapper-invoice__cnlfW .SelectPaymentBlock_view-pint-btn__pLt2v .SelectPaymentBlock_print-invoice__KHHST {
    width: 100%;
  }
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_service-num__w\\+xcT {
  color: #666666;
}
.SelectPaymentBlock_invoice-detail-modal__YJPh8 .SelectPaymentBlock_service-num__w\\+xcT a {
  color: #FFB034;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/base/_fonts.scss","webpack://./src/styles/SelectPaymentBlock.module.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAOA;EACE,kCAAA;EACA,oRAAA;ACHF;ADQA;EACE,gCAAA;EACA,wPAAA;ACNF;ADUA;EACE,0CAAA;EACA,wWAAA;ACRF;AAZA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;EACA,gCAAA;AAcJ;;AAXA,oBAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AAcJ;;AAXA,kCAAA;AACA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AAcJ;;AAXA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAcJ;;AAXA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAcJ;;AAXA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;AAcJ;;AAXA,6BAAA;AACA;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAcJ;;AAXA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAcJ;;AAXA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAcJ;;AAXA;EACI,eAAA;EACA,cAAA;EACA,6BAAA;EACA,gCAAA;AAcJ;AAZI;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;AAcR;;AAVA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAaJ;AAXI;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;AAaR;;AARA,eAAA;AACA;EACI;IACI,sBAAA;IACA,aAAA;EAWN;EARE;;IAEI,cAAA;IACA,kBAAA;EAUN;EAPE;IACI,gBAAA;IACA,6BAAA;EASN;EANE;IACI,UAAA;IACA,WAAA;IACA,SAAA;IACA,eAAA;EAQN;EALE;IACI,YAAA;IACA,QAAA;EAON;EAJE;IACI,eAAA;IACA,mBAAA;EAMN;AACF;AAHA;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,wBAAA;EACA,2BAAA;AAKJ;;AAFA,UAAA;AACA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAKJ;;AAFA,UAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,mBAAA;EACA,6IAAA;EAIA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAEJ;;AACA;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,iBAAA;EACA,mBAAA;EACA,sDAAA;AAEJ;;AACA;EACI,cAAA;AAEJ;;AACA;EACI,yBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;AAEJ;AACI;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACR;AACQ;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AACZ;AAGI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADR;AAII;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFR;;AAOA;EACI;IACI,2BAAA;EAJN;EAME;IACI,wBAAA;EAJN;AACF;AAMA;EACI,8BAAA;AAJJ;;AAMA;EACI,2CAAA;AAHJ;;AAMA;EACI,wBAAA;AAHJ;;AAKA;EACI,2BAAA;AAFJ;;AAIA;EACI;IACI,2BAAA;EADN;AACF;AAGA;EACI,0BAAA;AADJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAEA;EACI,oCAAA;AACJ;;AACA;EACI;IACI,yCAAA;EAEN;EAAE;IACI,8BAAA;EAEN;AACF;AAAA;EACI;IACI,2BAAA;EAEN;AACF;AAAA;EACI,iCAAA;AAEJ;;AAAA;EACI;IACI,aAAA;IACA,cAAA;EAGN;AACF;AADA;EACI;IACI,mBAAA;IACA,oBAAA;EAGN;AACF;AADA;EACI;IACI,0BAAA;EAGN;AACF;AADA;EACI;IACI,2BAAA;EAGN;AACF;AADA;EACI,6BAAA;AAGJ;;AADA;EACI;IACI,0BAAA;EAIN;AACF;AAFA;EACI;IACI,0BAAA;IACA,2BAAA;EAIN;EAHM;IACI,eAAA;EAKV;EAFE;IACI,oBAAA;EAIN;EAFE;IACI,mBAAA;EAIN;AACF;AADA;EACI,2BAAA;AAGJ;;AADA;EACI,2BAAA;AAIJ;;AAFA;EACI,yBAAA;AAKJ;;AAHA;EACI,2BAAA;AAMJ;;AAJA;EACI,2BAAA;AAOJ;;AALA;EACI,0BAAA;AAQJ;;AAJA;EACI;IACI,YAAA;EAON;AACF;AAJA;EACI;IACI,YAAA;EAMN;AACF;AAJA;EACI;IACI,WAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;EAMN;AACF;AAJA;EACI,MAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,oDAAA;EACA,eAAA;EACA,iBAAA;AAMJ;;AAJA;EACI;IACI,0BAAA;EAON;AACF;AALA;EACI,0BAAA;AAOJ;;AALA;EACI,2BAAA;AAQJ;;AANA;EACI,sBAAA;AASJ;;AAPA;EACI,6BAAA;AAUJ;;AARA;EACI,6BAAA;AAWJ;;AATA;EACI,yBAAA;AAYJ;;AAVA;EACI,oCAAA;AAaJ;;AAXA;EACI;IACI,0BAAA;EAcN;AACF;AAZA;EACI,0BAAA;AAcJ;;AAZA;EACI,2BAAA;AAeJ;;AAbA;EACI,sBAAA;AAgBJ;;AAdA;EACI,6BAAA;AAiBJ;;AAfA;EACI,6BAAA;AAkBJ;;AAhBA;EACI,yBAAA;AAmBJ;;AAjBA;EACI,oCAAA;AAoBJ;;AAlBA;EACI,kBAAA;EACA,qBAAA;EACA,+BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,uBAAA;AAqBJ;;AAnBA;EACI,MAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,oDAAA;EACA,eAAA;EACA,iBAAA;EACA,mBClXI;EDmXJ,0BAAA;EACA,2BAAA;EACA,qBAAA;AAsBJ;;AApBC;EACG,kBAAA;EACA,QAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,6CAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;AAuBJ;;AArBA;EACI,gBAAA;EACA,yDAAA;EACA,iCAAA;EACA,wBAAA;EACA,4BAAA;EACA,oBAAA;AAwBJ;;AAtBA;EACI,uBAAA;EACA,wBAAA;EACA,sBAAA;AAyBJ;;AAvBA;EACI,6BAAA;AA0BJ;;AAxBA;EACI,8BAAA;AA2BJ;;AAzBA;EACI;IACI,2BAAA;EA4BN;AACF;AA1BC;EACG,WAAA;EACA,YAAA;AA4BJ;;AA1BA;EACI,0BAAA;AA6BJ;;AA3BA;EACI;IACI,2BAAA;EA8BN;AACF;AA5BA;EACI,cAAA;AA8BJ;;AA5BA;EACI,sBAAA;AA+BJ;;AA7BA;EACI;IACI,0BAAA;IACA,gBChYH;IDiYG,gBAAA;EAgCN;AACF;AA9BA;EACI,2BAAA;AAgCJ;;AA7BA;EACI,2BAAA;AAgCJ;;AA9BA;EACI;IACI,2BAAA;EAiCN;AACF;AA/BA;EACI,cCvdW;ADwff;;AA9BA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AAiCJ;AA/BI;EACI,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAiCR;;AA7BA;EACI,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;AAgCJ;;AA7BA;EACI,aAAA;EACA,WAAA;EACA,eAAA;AAgCJ;;AA7BA;EACI,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AAgCJ;AA9BI;EARJ;IASQ,cAAA;EAiCN;AACF;;AA9BA;EACI,WAAA;AAiCJ;;AA9BA;EACI,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAiCJ;;AA9BA;EACI,gCAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAiCJ;;AA9BA;EACI,gBAAA;EACA,qBAAA;AAiCJ;;AA9BA;EACI,sBAAA;EACA,kBAAA;AAiCJ;;AA9BA;EACI,gCAAA;EACA,eAAA;EACA,wBAAA;EACA,oBAAA;AAiCJ;AA/BI;EACI,gBAAA;AAiCR;;AA7BA;EAEI,8BAAA;EACA,kBAAA;AA+BJ;;AA1BA;EACI,eAAA;EACA,eAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;AA6BJ;;AA1BA;EACI,iBAAA;AA6BJ;;AA1BA;EACI,gCAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;AA6BJ;;AA1BA;EACI,oBAAA;AA6BJ;;AA1BA;EACI,8BAAA;EACA,wBAAA;AA6BJ;;AA1BI;EACI,gBAAA;EACA,iBAAA;AA6BR;AA5BQ;EAHJ;IAIQ,aAAA;EA+BV;AACF;AA9BQ;EACI,cC9jBF;ED+jBE,gBAAA;AAgCZ;AA9BQ;EACI,mBAAA;EACA,oBAAA;AAgCZ;AA/BY;EAHJ;IAIQ,mBAAA;IACA,kBAAA;EAkCd;AACF;AAjCY;EACI,cAAA;EACA,gBCriBX;EDsiBW,gBAAA;EACA,iBAAA;AAmChB;AAhCQ;EACI,aAAA;EACA,YAAA;EACA,kEAAA;EACA,2BAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,YCjkBF;ADmmBV;AAjCY;EATJ;IAUQ,mBAAA;IACA,eAAA;EAoCd;AACF;AAnCa;EACG,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,cCnpBR;EDopBQ,kBAAA;EACA,YAAA;EACA,qBAAA;AAqChB;AApCgB;EACI,eAAA;EACA,gBChkBf;EDikBe,cCzpBZ;AD+rBR;AAlCQ;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAoCZ;AA/BQ;EACI,mBCxqBJ;EDyqBI,aC9lBD;AD+nBX;AAhCY;EACI,cC7pBD;AD+rBf;AAjCgB;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAmCpB;AAlCoB;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAoCxB;AAnCwB;EANJ;IAOQ,eAAA;EAsC1B;AACF;AArCwB;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBC7mBvB;ED8mBuB,eAAA;EACA,mBAAA;EACA,oBAAA;AAuC5B;AAtC4B;EAVJ;IAWQ,eAAA;IACA,cAAA;IACA,kBAAA;EAyC9B;AACF;AAxC4B;EACI,cAAA;AA0ChC;AAxC4B;EACI,gBAAA;AA0ChC;AAvCwB;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AAyC5B;AAxC4B;EAVJ;IAWQ,eAAA;IACA,cAAA;IACA,kBAAA;EA2C9B;AACF;AA1C4B;EACI,gBAAA;AA4ChC;AA1C4B;EACI,cCrsBxB;EDssBwB,gBC7oB3B;ED8oB2B,cAAA;EACA,aAAA;AA4ChC;AA3CgC;EACI,UAAA;AA6CpC;AAzCwB;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AA2C5B;AA1C4B;EARJ;IASQ,eAAA;IACA,cAAA;IACA,kBAAA;IACA,gBAAA;EA6C9B;AACF;AA5C4B;EACI,aAAA;EACA,iBAAA;EACA,mBC/tBxB;EDguBwB,kBAAA;AA8ChC;AA7CiC;EACG,cCjwB5B;EDkwB4B,UAAA;EACA,SAAA;EACA,eAAA;EACA,gBC3qB/B;AD0tBL;AA7CgC;EACI,cCxwB5B;EDywB4B,gBCprB/B;ADmuBL;AA1CoB;EACI,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBChuBb;AD4wBX;AA3CwB;EACI,cCtxBpB;EDuxBoB,gBCjsBvB;EDksBuB,gBAAA;AA6C5B;AA3CwB;EACI,cC3vBpB;ED4vBoB,cAAA;AA6C5B;AA3CwB;EACI,gBAAA;AA6C5B;AA3CwB;EACI,WAAA;EACA,yBAAA;AA6C5B;AA5C4B;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;AA8ChC;AA5C4B;EACI,cC3yBxB;ED4yBwB,gBCntB3B;EDotB2B,gBAAA;AA8ChC;AA5C4B;EACI,cAAA;AA8ChC;AA5C4B;EACI,mBAAA;AA8ChC;AAzCwB;EACI,mBCnxBpB;EDoxBoB,cCzzBpB;ED0zBoB,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBCruBvB;EDsuBuB,iBAAA;AA2C5B;AA1C4B;EACI,0BAAA;AA4ChC;AA1C4B;EAXJ;IAYQ,sBAAA;IACA,eAAA;IACA,cAAA;IACA,kBAAA;IAEA,SAAA;IACA,WAAA;EA4C9B;AACF;AA1CwB;EACI,mBCj0BpB;EDk0BoB,cC90BpB;ED+0BoB,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBC1vBvB;ED2vBuB,iBAAA;AA4C5B;AA3C4B;EACI,0BAAA;AA6ChC;AA3C4B;EAXJ;IAYQ,WAAA;EA8C9B;AACF;AAvCI;EACI,cCn1BO;AD43Bf;AAxCQ;EACI,cC9zBJ;ED+zBI,qBAAA;AA0CZ","sourcesContent":["// -----------------------------------------------------------------------------\n// This file contains all @font-face declarations, if any.\n// -----------------------------------------------------------------------------\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap');\n\n@font-face {\n  font-family: \"DM Sans\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff2'),\n  url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff');\n  \n}\n\n@font-face {\n  font-family: \"Inter\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff');\n}\n\n@font-face {\n  font-family: \"Source Sans Pro\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff');\n}","@use './abstracts/variables' as *;\n\n.selectPaymentBlock {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    padding-bottom: 40px;\n    font-family: \"Inter\", sans-serif;\n}\n\n/* Agreement block */\n.agreement {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    border-radius: 8px;\n    background-color: #fff;\n    position: relative;\n}\n\n/* LEFT: service info + checkbox */\n.agreementHeader {\n    flex: 1 1 70%;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding-left: 20px;\n    border: 1px solid;\n    background-color: #f5f5f5;\n}\n\n.agreementCheckbox {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    padding: 10px;\n}\n\n.salesAgrNum {\n    font-size: 14px;\n    font-weight: 600;\n    color: #414141;\n}\n\n.serviceLabel {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    color: #222222;\n    font-family: \"Inter\", sans-serif;\n}\n\n/* RIGHT: pricing + tooltip */\n.agreementDetails {\n    flex: 1 1 20%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-left: 20px;\n    position: relative;\n    border: 1px solid;\n}\n\n.amountRow {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.payNowLabel {\n    font-size: 14px;\n    font-weight: 500;\n    color: #333;\n    padding-top: 10px;\n}\n\n.agrAmount {\n    font-size: 16px;\n    color: #8a94a6;\n    text-decoration: line-through;\n    font-family: \"Inter\", sans-serif;\n\n    sup {\n        font-size: 11px;\n        vertical-align: top;\n        margin-left: 1px;\n    }\n}\n\n.totalAmount {\n    font-size: 28px;\n    font-weight: 700;\n    color: #39d25a;\n\n    sup {\n        font-size: 14px;\n        vertical-align: top;\n        margin-left: 4px;\n\n    }\n}\n\n/* Responsive */\n@media screen and (max-width: 767px) {\n    .agreement {\n        flex-direction: column;\n        padding: 16px;\n    }\n\n    .agreementHeader,\n    .agreementDetails {\n        flex: 1 1 100%;\n        border-right: none;\n    }\n\n    .agreementDetails {\n        margin-top: 12px;\n        border-top: 1px solid #e4e6eb;\n    }\n\n    .tooltipRow {\n        left: auto;\n        right: 12px;\n        top: 12px;\n        transform: none;\n    }\n\n    .tooltipText {\n        width: 300px;\n        left: 0%;\n    }\n\n    .totalAmount {\n        font-size: 32px;\n        line-height: 36.8px;\n    }\n}\n\n.tooltipContainer {\n    position: absolute;\n    top: 50%;\n    right: -20px;\n    /* push outside border */\n    transform: translateY(-50%);\n}\n\n/* Badge */\n.tooltipBadge {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background-color: #f4a100;\n    color: #fff;\n    font-weight: 700;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Popup */\n.tooltipText {\n    display: none;\n    position: absolute;\n    left: 40px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: #080808;\n    box-shadow: 0px 7px 7px rgba(0, 0, 0, 0.09),\n        0px 2px 4px rgba(0, 0, 0, 0.10),\n        0px 0px 8px rgba(0, 0, 0, 0.10),\n        0px 0px 24px rgba(0, 0, 0, 0.16);\n    padding: 12px 16px;\n    border-radius: 8px;\n    width: 280px;\n    font-size: 14px;\n    line-height: 18px;\n    color: #f7f3f3;\n    z-index: 10;\n}\n\n.tooltipText::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: -6px;\n    transform: translateY(-50%);\n    border-width: 6px;\n    border-style: solid;\n    border-color: transparent #fff transparent transparent;\n}\n\n.tooltipBadge:hover+.tooltipText {\n    display: block;\n}\n\n.paymentSummaryBox {\n    background-color: #414141; // dark background\n    color: #ffffff;\n    padding: 24px;\n    max-width: 240px;\n    margin-left: auto;\n\n\n    p {\n        margin: 0;\n        font-size: 16px;\n        font-weight: 500;\n        line-height: 0.6;\n\n        &:first-of-type {\n            font-size: 18px;\n            font-weight: 600;\n            margin-bottom: 8px;\n        }\n    }\n\n    span {\n        display: block;\n        margin-top: 12px;\n        font-size: 28px;\n        font-weight: 700;\n        color: #ffffff;\n    }\n\n    .savings {\n        margin-top: 8px;\n        font-size: 14px;\n        font-weight: 400;\n        color: #00c853; // green savings text\n    }\n}\n\n// New\n@media (min-width: 768px) {\n    .mb-md-0 {\n        margin-bottom: 0 !important;\n    }\n    .p-10{\n        padding: 10px !important;\n    }\n}\n.mb-20 {\n    margin-bottom: 20px !important;\n}\n.border-bottom {\n    border-bottom: 1px solid #6c757d !important;\n}\n\n.p-30 {\n    padding: 30px !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n@media (min-width: 768px) {\n    .text-md-left {\n        text-align: left !important;\n    }\n}\n.g-font-size-24, .gfs-24 {\n    font-size: 24px !important;\n}\n.gfs-md-22 {\n    font-size: 22px;\n}\n\n.g-line-height-1, .glh-1 {\n    line-height: 1 !important;\n}\n.tru-mma-main-add, .tru-mma-main-content-box, .tru-mma-main-service-box, .tru-mma-main-wrapper {\n    border: 1px solid #6c757d !important;\n}\n@media (min-width: 768px) {\n    .mma-wrapper .tru-mma-main-wrapper .tru-mma-main-content-box .tru-mma-main-side {\n        border-left: 1px solid #6c757d !important;\n    }\n    .tru-mma-main-side {\n        border-left: 1px solid #6c757d;\n    }\n}\n@media (min-width: 992px) {\n    .text-lg-left {\n        text-align: left !important;\n    }\n}\n.bg-white {\n    background-color: #fff !important;\n}\n@media (min-width: 992px) {\n    .col-lg-3 {\n        flex: 0 0 25%;\n        max-width: 25%;\n    }\n}\n@media (min-width: 768px) {\n    .col-md-4 {\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%;\n    }\n}\n@media (min-width: 992px) {\n    .g-font-size-lg-16, .gfs-lg-16 {\n        font-size: 16px !important;\n    }\n}\n@media (min-width: 992px) {\n    .text-lg-left {\n        text-align: left !important;\n    }\n}\n.g-text-strike {\n    text-decoration: line-through;\n}\n@media (min-width: 768px) {\n    .g-font-size-md-40, .gfs-md-40 {\n        font-size: 40px !important;\n    }    \n}\n@media (max-width: 767px) {\n    .text-green {\n        font-size: 50px !important;\n        font-weight: 700 !important;\n        sup{\n            font-size: 26px;\n        }\n    }\n    .tru-mma-main-content-box{\n        border: 0 !important;\n    }\n    .service-tooltip{\n        right:0 !important;\n    }\n\n}\n.g-font-weight-700, .gfw-7 {\n    font-weight: 700 !important;\n}\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n.text-green {\n    color: #73c573 !important;\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n.g-font-size-14, .gfs-14 {\n    font-size: 14px !important;\n}\n\n\n@media only screen and (min-width: 768px) {\n    .mma-wrapper .tru-mma-main-side .service-tooltip {\n        right: -18px;\n    }\n}\n\n@media only screen and (min-width: 768px) {\n    .mma-wrapper .service-tooltip {\n        right: -50px;\n    }\n}\n@media (min-width: 768px) {\n    .mma-wrapper .service-tooltip {\n        right: -2px;\n        width: 40px;\n        height: 40px;\n        line-height: 40px;\n    }\n}\n.mma-wrapper .service-tooltip {\n    top: 0;\n    right: -11px;\n    bottom: 0;\n    width: 30px;\n    height: 30px;\n    margin: auto;\n    box-shadow: -2px 2px 0 0 hsla(0, 0%, 84.7%, .74902);\n    cursor: pointer;\n    line-height: 30px;\n}\n@media (min-width: 768px) {\n    .g-font-size-md-32, .gfs-md-32 {\n        font-size: 32px !important;\n    }\n}\n.g-font-size-24, .gfs-24 {\n    font-size: 24px !important;\n}\n.g-font-weight-700, .gfw-7 {\n    font-weight: 700 !important;\n}\n.text-white {\n    color: #fff !important;\n}\n.text-center {\n    text-align: center !important;\n}\n.position-absolute {\n    position: absolute !important;\n}\n.d-block {\n    display: block !important;\n}\n.bg-secondary {\n    background-color: #ffb034 !important;\n}\n@media (min-width: 768px) {\n    .g-font-size-md-32, .gfs-md-32 {\n        font-size: 32px !important;\n    }\n}\n.g-font-size-24, .gfs-24 {\n    font-size: 24px !important;\n}\n.g-font-weight-700, .gfw-7 {\n    font-weight: 700 !important;\n}\n.text-white {\n    color: #fff !important;\n}\n.text-center {\n    text-align: center !important;\n}\n.position-absolute {\n    position: absolute !important;\n}\n.d-block {\n    display: block !important;\n}\n.bg-secondary {\n    background-color: #ffb034 !important;\n}\n.tooltipReg {\n    position: relative;\n    display: inline-block;\n    border-bottom: 1px dotted black;\n    width: 40px !important;\n    height: 40px !important;\n    line-height: 40px !important;\n    right: -40px !important;\n}\n.service-tooltip {\n    top: 0;\n    right: -40px;\n    bottom: 0;\n    width: 40px;\n    height: 40px;\n    margin: auto;\n    box-shadow: -2px 2px 0 0 hsla(0, 0%, 84.7%, .74902);\n    cursor: pointer;\n    line-height: 40px;\n    background: $yellow;\n    font-size: 32px !important;\n    font-weight: $fw7 !important;\n    text-decoration: none;\n}\n .service-tooltip:after {\n    position: absolute;\n    right: 0;\n    bottom: -10px;\n    width: 0;\n    height: 0;\n    border-color: #a95f1e transparent transparent;\n    border-style: solid;\n    border-width: 10px 10px 0 0;\n    content: \"\";\n}\ninput[type=checkbox]:checked {\n    border-radius: 0;\n    background-image: url(../../public/images/check-white.png);\n    background-color: #666 !important;\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: 60%;\n}\n.select-all-check, .select-all-radio {\n    height: 25px !important;\n    min-height: 0 !important;\n    width: 25px !important;\n}\n.mr-10 {\n    margin-right: 10px !important;\n}\n.mb-20 {\n    margin-bottom: 20px !important;\n}\n@media (min-width: 768px) {\n    .mb-md-0 {\n        margin-bottom: 0 !important;\n    }\n}\n .img-fluid {\n    width: 24px;\n    height: 24px;\n}\n.gfs-20 {\n    font-size: 20px !important;\n}\n@media (min-width: 768px) {\n    .text-md-left {\n        text-align: left !important;\n    }\n}\n.clr-amt {\n    color: #303236;\n}\n.text-white {\n    color: #fff !important;\n}\n@media (min-width: 992px) {\n    .g-font-size-lg-16, .gfs-lg-16 {\n        font-size: 16px !important;\n        font-weight: $fw3;\n        line-height: 1.2;\n    }\n}\n.g-font-weight-300, .gfw-3 {\n    font-weight: 300 !important;\n}\n\n.g-line-height-1_2, .glh-1_2 {\n    line-height: 1.2 !important;\n}\n@media (min-width: 768px) {\n    .mt-md-10 {\n        margin-top: 10px !important;\n    }\n}\n.text-grey {\n    color: $light-gray2;\n}\n\n.one-time-open-invoice {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    min-height: 200px;\n    height: auto;\n    width: 100%;\n\n    h3 {\n        font-family: \"DM Sans\", sans-serif;\n        font-size: 28px;\n        font-weight: 700;\n        line-height: 34px;\n        color: #303236;\n        margin-bottom: 0;\n    }\n}\n\n.one-time-subtext {\n    margin-top: -5px;\n    margin-bottom: 0;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    color: #6c757d;\n}\n\n.one-time-invoice-container {\n    display: flex;\n    gap: 0 20px;\n    flex-wrap: wrap;\n}\n\n.one-time-invoice-box {\n    display: flex;\n    border: 1px solid #c6c6c6;\n    padding: 16px;\n    border-radius: 4px;\n    margin-bottom: 20px;\n    flex: 0 1 48%;\n\n    @media only screen and (max-width: 767px) {\n        flex: 0 1 100%;\n    }\n}\n\n.one-time-invoice-box-content {\n    width: 100%;\n}\n\n.one-time-form-check-label span {\n    font-weight: 500;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    color: #303236;\n    margin-left: 0;\n}\n\n.one-time-checkmark {\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    color: #303236;\n    border-radius: 3px;\n    margin-top: 3px;\n    border-color: #d2d6de;\n    width: 18px;\n    height: 18px;\n    margin-right: 10px;\n}\n\n.one-time-checkmark:focus {\n    box-shadow: none;\n    border-color: #d2d6de;\n}\n\n.one-time-checkmark:checked {\n    background-color: #666;\n    border-color: #666;\n}\n\n.one-time-due-amount {\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    color: hsl(220, 6%, 20%);\n    margin: 0 0 0px 38px;\n\n    span {\n        font-weight: 700;\n    }\n}\n\n.one-time-due-date {\n    // display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n}\n\n\n\n.one-time-see-more {\n    text-align: end;\n    cursor: pointer;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    color: #73c573;\n    text-decoration: underline;\n}\n\n.one-time-invoice-link-row {\n    margin-left: 28px;\n}\n\n.one-time-view-invoice {\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    color: #303236;\n    text-decoration: underline;\n}\n\n.one-time-modal-lines {\n    padding-bottom: 30px;\n}\n\n.bg-dark-pay-now{\n    background: $light-gray !important;\n    padding: 10px !important;\n}\n.invoice-detail-modal{    \n    .modal-dialog-invoice {\n        max-width: 900px;\n        margin: 28px auto;\n        @media (max-width:767px) {\n            margin:0 5px;\n        }\n        .modal-content-invoice {\n            color: $bl-green;\n            border-radius: 0;\n        }\n        .left-white {\n            flex: 0 0 83.33333%;\n            max-width: 83.33333%;\n            @media (max-width:767px) {\n                max-width: 58.3333%;\n                flex: 0 0 58.3333%;\n            }\n            p {\n                font-size: 1em;\n                font-weight: $fw4;\n                margin-top: 30px;\n                margin-left: 30px;\n            }\n        }\n        .fold {\n            height: 100px;\n            width: 100px;\n            background: #999 url(../../public/images/myAccount/invoice-fold-right-top.png) no-repeat;\n            background-position: 100% 0;\n            flex: 0 0 16.66667%;\n            max-width: 16.66667%;\n            min-width: 75px;\n            padding: $padding0;\n            @media (max-width:767px) {\n                max-width: 37.6667%;\n                flex: 0 0 36.5%;\n            }\n             .ntrclose-button {\n                width: 60px;\n                height: 60px;\n                padding-top: 18px;\n                line-height: 0;\n                padding-left: 18px;\n                color: $black;\n                text-align: center;\n                float: right;\n                text-decoration: none;\n                span {\n                    font-size: 60px;\n                    font-weight: $fw7;\n                    color: $white;\n                }\n            }\n        }\n        .wrapper-invoice {\n            width: 100%;\n            padding-right: 12px;\n            padding-left: 12px;\n            margin-right: auto;\n            margin-left: auto;\n            @media (max-width:767px) {\n                \n            }\n        }                    \n        .white-wrapper {\n            background: $white;\n            padding:$padding30;\n            .bg-white {\n                color: $light-gray2;\n                .wrapper-invoice {\n                    width: 100%;\n                    padding-right: 15px;\n                    padding-left: 15px;\n                    margin-right: auto;\n                    margin-left: auto;\n                    .main {\n                        display: flex;\n                        flex-wrap: wrap;\n                        margin-right: -15px;\n                        margin-left: -15px;\n                        margin-bottom: 30px;\n                        @media (max-width:767px) {\n                            flex-wrap: wrap;\n                        }\n                        .addr {\n                            position: relative;\n                            width: 100%;\n                            min-height: 1px;\n                            padding-right: 15px;\n                            padding-left: 15px;\n                            font-weight: $fw3;\n                            font-size: 24px;\n                            flex: 0 0 33.33333%;\n                            max-width: 33.33333%;\n                            @media (max-width:767px) {\n                                max-width: 100%;\n                                flex: 0 0 100%;\n                                text-align: center;\n                            }\n                            .name {\n                                font-size: 1em;\n                            }\n                            .cust-number {\n                                font-size: .5em;\n                            }\n                        }\n                        .invoice-amount {\n                            height: 116px;\n                            position: relative;\n                            width: 100%;\n                            min-height: 1px;\n                            padding-right: 15px;\n                            padding-left: 15px;\n                            text-align: center;\n                            flex: 0 0 33.33333%;\n                            max-width: 33.33333%;\n                            @media (max-width:767px) {\n                                max-width: 100%;\n                                flex: 0 0 100%;\n                                text-align: center;\n                            }\n                            .amount-title {\n                                font-size: 1.5em;\n                            }\n                            .amount {\n                                color: $green7;\n                                font-weight: $fw7;\n                                font-size: 3em;\n                                margin-top: 0;\n                                .tg-ml-11{\n                                    top: -10px;\n                                }\n                            }\n                        }\n                        .invoice-status {\n                            position: relative;\n                            width: 100%;\n                            min-height: 1px;\n                            padding-right: 15px;\n                            padding-left: 15px;\n                            flex: 0 0 33.33333%;\n                            max-width: 33.33333%;\n                            @media (max-width:767px) {\n                                max-width: 100%;\n                                flex: 0 0 100%;\n                                text-align: center;\n                                margin-top:30px;\n                            }\n                            .invoice-status-paid {\n                                height: 116px;\n                                padding-top: 30px;\n                                background: $green7;\n                                text-align: center;\n                                 h2 {\n                                    color: $white;\n                                    padding: 0;\n                                    margin: 0;\n                                    font-size: 44px;\n                                    font-weight: $fw9;\n                                }\n                                p {\n                                    color: $white;\n                                    font-weight: $fw4;\n                                }\n                            }\n                        }\n                    }\n                    .service {\n                        margin-top: 30px;\n                        margin-bottom: 30px;\n                        padding: 30px;\n                        border: 1px solid $grey5;\n                        background: $bg-white2;\n                        .service-title {\n                            color: $black;\n                            font-weight: $fw4;\n                            font-size: 1.2em;\n                        }\n                        .service-date {\n                            color: $green7;\n                            font-size: 1em;\n                        }\n                        .service-table-wrapper {\n                            overflow-x: auto;\n                        }\n                        .service-table {\n                            width: 100%;\n                            border-collapse: collapse;\n                            th, td {\n                                padding: 10px 12px;\n                                text-align: left;\n                                white-space: nowrap;\n                                border-bottom: 1px solid $grey5;\n                            }\n                            th {\n                                color: $black;\n                                font-weight: $fw7;\n                                font-size: 0.9em;\n                            }\n                            .service-title {\n                                font-size: 1em;\n                            }\n                            .view-invoice-ticket {\n                                white-space: nowrap;\n                            }\n                        }\n                    }\n                    .view-pint-btn{\n                        .view-invoice-ticket{\n                            background: $yellow;\n                            color:$white;\n                            border-radius: 0;\n                            line-height: 1.3;\n                            font-size: 18px;\n                            font-weight: $fw7;\n                            padding: 8px 18px;\n                            &:hover{\n                                text-decoration: underline;\n                            }\n                            @media (max-width:767px) {\n                                flex-direction: column;\n                                max-width: 100%;\n                                flex: 0 0 100%;\n                                text-align: center;\n                                // margin-top:30px;\n                                gap:30px;\n                                width:100%\n                            }\n                        }\n                        .print-invoice{\n                            background: $gray11;\n                            color:$white;\n                            border-radius: 0;\n                            line-height: 1.3;\n                            font-size: 18px;\n                            font-weight: $fw7;\n                            padding: 8px 18px;\n                            &:hover{\n                                text-decoration: underline;\n                            }\n                            @media (max-width:767px) {\n                                width:100%\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .service-num{\n        color:$light-gray2;\n        a{\n            color:$yellow;\n            text-decoration: none;\n        }\n    }\n}","// -----------------------------------------------------------------------------\n// This file contains all application-wide Sass variables.\n// -----------------------------------------------------------------------------\n\n\n//Fonts \n\n\n@import \"../base/fonts\";\n\n\n$roboto-regular : 'Roboto-regular';\n$roboto-bold: 'Roboto-bold';\n$roboto-medium: 'Roboto-medium';\n$roboto-light-italic: 'Roboto-light-italic';\n\n/// Regular font family\n/// @type List\n//$text-font-stack: 'Open Sans', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !default;\n\n/// Code (monospace) font family\n/// @type List\n//$code-font-stack: 'Courier New', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Monaco', monospace !default;\n\n\n\n\n\n/// Copy text color\n/// @type Color\n$text-color: rgb(34, 34, 34) !default;\n\n/// Main brand color\n/// @type Color\n$brand-color: rgb(229, 0, 80) !default;\n\n/// Light grey\n/// @type Color\n$light-grey: rgb(237, 237, 237) !default;\n\n/// Medium grey\n/// @type Color\n$mid-grey: rgb(153, 153, 153) !default;\n\n/// Dark grey\n/// @type Color\n$dark-grey: rgb(68, 68, 68) !default;\n\n$black: #000000;\n$white: #ffffff;\n$gray: #222222;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n\n$hover-grey: #b8babf;\n$gray7:#333333;\n$gray8:#CCCCCC;\n$gray9:#dddddd;\n$gray10:#57606a;\n$gray11:#999999;\n$light-gray : #414141;\n$light-gray2 : #666666;\n$gray2 : #4F4F4F;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n$grey7 : #d9d9d9;\n$grey8 : #e6e9ee;\n$grey9 : #e6e6e9;\n$hover-grey: #b8babf;\n$stone : #CACACA;\n$gray-bg :#EBF9F0;\n$green:#046A38;\n$green2:#1EE576;\n$green3:#19C063;\n$green5:#2a8056;\n$green4:#73c573;\n$green7:#70c66f;\n$dark-green:#00873C;\n$light-green:#00B140;\n$light-green1 : #4f785f;\n$red : #FF0000;\n$light-red:#ff3c3c;\n$yellow:#FFB034;\n$dark-yellow:#e2a014;\n$yellow-hover:#cd7d00;\n$blue :#0A1AB4;\n$orange:#EA6B1F;\n$purple:#6A1B85;\n$offwhite:#F5F7F5;\n$offwhite1:#E0E0E0;\n$bg-grey-login:#f2f3f6;\n$border-grey: #ced4da;\n$bl-grey: #6c757d;\n$bl-green:#00703c;\n$bl-darkgrey: #b0b0b0;\n$bg-white1:#F5F5F5;\n$bg-white2:#FAFAFA;\n$red1: #d1002f;\n\n$yellow-hover:#cd7d00;\n\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$margin0:0px;\n$margin10:10px;\n$margin15:15px; \n$margin20:20px;\n$margin30:30px; \n$margin40:40px;\n$margin50:50px;\n$margin60:60px;\n\n$padding0:0px;\n$padding10:10px;\n$padding15:15px;    \n$padding16:16px;    \n$padding20:20px;\n$padding30:30px;  \n$padding40:40px;\n$padding50:50px;\n\n$br-0:0px;\n\n$br-0:0px;\n$fw1:100;\n$fw2:200;\n$fw3:300;\n$fw4:400;\n$fw5:500;\n$fw6:600;\n$fw7:700;\n$fw8:800;\n$fw9:900;\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$source-sans-pro:   \"Source Sans Pro\" , sans-serif ;\n\n/// Container's maximum width\n/// @type Length\n$max-width: 1180px !default;\n\n\n\n\n\n/// Breakpoints map\n/// @prop {String} keys - Keys are identifiers mapped to a given length\n/// @prop {Map} values - Values are actual breakpoints expressed in pixels\n$breakpoints: (\n  'small': 320px,\n  'medium': 768px,\n  'large': 1024px,\n) !default;\n\n\n\n\n\n\n/// Relative or absolute URL where all assets are served from\n/// @type String\n/// @example scss - When using a CDN\n///   $base-url: 'https://cdn.example.com/assets/';\n$base-url: '/assets/' !default;\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectPaymentBlock": `SelectPaymentBlock_selectPaymentBlock__ZF58i`,
	"agreement": `SelectPaymentBlock_agreement__Su556`,
	"agreementHeader": `SelectPaymentBlock_agreementHeader__NKg3s`,
	"agreementCheckbox": `SelectPaymentBlock_agreementCheckbox__hMN4O`,
	"salesAgrNum": `SelectPaymentBlock_salesAgrNum__mvyf5`,
	"serviceLabel": `SelectPaymentBlock_serviceLabel__AVYOq`,
	"agreementDetails": `SelectPaymentBlock_agreementDetails__0Tpt+`,
	"amountRow": `SelectPaymentBlock_amountRow__7ulMr`,
	"payNowLabel": `SelectPaymentBlock_payNowLabel__XOdjO`,
	"agrAmount": `SelectPaymentBlock_agrAmount__dqQLd`,
	"totalAmount": `SelectPaymentBlock_totalAmount__SrJN6`,
	"tooltipRow": `SelectPaymentBlock_tooltipRow__LHI-V`,
	"tooltipText": `SelectPaymentBlock_tooltipText__+XKyY`,
	"tooltipContainer": `SelectPaymentBlock_tooltipContainer__oYFEM`,
	"tooltipBadge": `SelectPaymentBlock_tooltipBadge__0tsNZ`,
	"paymentSummaryBox": `SelectPaymentBlock_paymentSummaryBox__tBoe1`,
	"savings": `SelectPaymentBlock_savings__HkL5T`,
	"mb-md-0": `SelectPaymentBlock_mb-md-0__B9c1I`,
	"p-10": `SelectPaymentBlock_p-10__NP6j5`,
	"mb-20": `SelectPaymentBlock_mb-20__jLCRP`,
	"border-bottom": `SelectPaymentBlock_border-bottom__sGzHR`,
	"p-30": `SelectPaymentBlock_p-30__GELuM`,
	"g-font-weight-300": `SelectPaymentBlock_g-font-weight-300__hSmoK`,
	"gfw-3": `SelectPaymentBlock_gfw-3__bPgkf`,
	"text-md-left": `SelectPaymentBlock_text-md-left__IiorS`,
	"g-font-size-24": `SelectPaymentBlock_g-font-size-24__VUBuK`,
	"gfs-24": `SelectPaymentBlock_gfs-24__jddBf`,
	"gfs-md-22": `SelectPaymentBlock_gfs-md-22__YSg9T`,
	"g-line-height-1": `SelectPaymentBlock_g-line-height-1__rElOa`,
	"glh-1": `SelectPaymentBlock_glh-1__6lHT-`,
	"tru-mma-main-add": `SelectPaymentBlock_tru-mma-main-add__PhxiX`,
	"tru-mma-main-content-box": `SelectPaymentBlock_tru-mma-main-content-box__3k3Rb`,
	"tru-mma-main-service-box": `SelectPaymentBlock_tru-mma-main-service-box__t0W-B`,
	"tru-mma-main-wrapper": `SelectPaymentBlock_tru-mma-main-wrapper__ii+D-`,
	"mma-wrapper": `SelectPaymentBlock_mma-wrapper__ujeDz`,
	"tru-mma-main-side": `SelectPaymentBlock_tru-mma-main-side__xGOTL`,
	"text-lg-left": `SelectPaymentBlock_text-lg-left__+M20N`,
	"bg-white": `SelectPaymentBlock_bg-white__Rzm1e`,
	"col-lg-3": `SelectPaymentBlock_col-lg-3__AINdq`,
	"col-md-4": `SelectPaymentBlock_col-md-4__Bag5B`,
	"g-font-size-lg-16": `SelectPaymentBlock_g-font-size-lg-16__KLRa0`,
	"gfs-lg-16": `SelectPaymentBlock_gfs-lg-16__-fagT`,
	"g-text-strike": `SelectPaymentBlock_g-text-strike__OGu5l`,
	"g-font-size-md-40": `SelectPaymentBlock_g-font-size-md-40__QZJT6`,
	"gfs-md-40": `SelectPaymentBlock_gfs-md-40__16L33`,
	"text-green": `SelectPaymentBlock_text-green__MLL9P`,
	"service-tooltip": `SelectPaymentBlock_service-tooltip__ydzhE`,
	"g-font-weight-700": `SelectPaymentBlock_g-font-weight-700__qQ3Fh`,
	"gfw-7": `SelectPaymentBlock_gfw-7__wnUix`,
	"g-line-height-1_2": `SelectPaymentBlock_g-line-height-1_2__Ul3mQ`,
	"glh-1_2": `SelectPaymentBlock_glh-1_2__PpsYt`,
	"g-font-size-14": `SelectPaymentBlock_g-font-size-14__-18y9`,
	"gfs-14": `SelectPaymentBlock_gfs-14__evAbY`,
	"g-font-size-md-32": `SelectPaymentBlock_g-font-size-md-32__7Ixdk`,
	"gfs-md-32": `SelectPaymentBlock_gfs-md-32__s5WO9`,
	"text-white": `SelectPaymentBlock_text-white__wRJU5`,
	"text-center": `SelectPaymentBlock_text-center__QdNHm`,
	"position-absolute": `SelectPaymentBlock_position-absolute__fkx5F`,
	"d-block": `SelectPaymentBlock_d-block__7dxmq`,
	"bg-secondary": `SelectPaymentBlock_bg-secondary__n7utl`,
	"tooltipReg": `SelectPaymentBlock_tooltipReg__B0gpi`,
	"select-all-check": `SelectPaymentBlock_select-all-check__pcVeJ`,
	"select-all-radio": `SelectPaymentBlock_select-all-radio__BGQcv`,
	"mr-10": `SelectPaymentBlock_mr-10__CH9tc`,
	"img-fluid": `SelectPaymentBlock_img-fluid__xTLb4`,
	"gfs-20": `SelectPaymentBlock_gfs-20__ZtoTg`,
	"clr-amt": `SelectPaymentBlock_clr-amt__38T1V`,
	"mt-md-10": `SelectPaymentBlock_mt-md-10__xSiLD`,
	"text-grey": `SelectPaymentBlock_text-grey__oHScB`,
	"one-time-open-invoice": `SelectPaymentBlock_one-time-open-invoice__dOGmC`,
	"one-time-subtext": `SelectPaymentBlock_one-time-subtext__okOL1`,
	"one-time-invoice-container": `SelectPaymentBlock_one-time-invoice-container__QGL3+`,
	"one-time-invoice-box": `SelectPaymentBlock_one-time-invoice-box__YaMHH`,
	"one-time-invoice-box-content": `SelectPaymentBlock_one-time-invoice-box-content__YJryY`,
	"one-time-form-check-label": `SelectPaymentBlock_one-time-form-check-label__EJGmt`,
	"one-time-checkmark": `SelectPaymentBlock_one-time-checkmark__q9NTO`,
	"one-time-due-amount": `SelectPaymentBlock_one-time-due-amount__rHAS2`,
	"one-time-due-date": `SelectPaymentBlock_one-time-due-date__YbiXc`,
	"one-time-see-more": `SelectPaymentBlock_one-time-see-more__AQZhL`,
	"one-time-invoice-link-row": `SelectPaymentBlock_one-time-invoice-link-row__pDl8r`,
	"one-time-view-invoice": `SelectPaymentBlock_one-time-view-invoice__mn1FS`,
	"one-time-modal-lines": `SelectPaymentBlock_one-time-modal-lines__iDt1o`,
	"bg-dark-pay-now": `SelectPaymentBlock_bg-dark-pay-now__DjsIo`,
	"invoice-detail-modal": `SelectPaymentBlock_invoice-detail-modal__YJPh8`,
	"modal-dialog-invoice": `SelectPaymentBlock_modal-dialog-invoice__kRimR`,
	"modal-content-invoice": `SelectPaymentBlock_modal-content-invoice__Yv+5T`,
	"left-white": `SelectPaymentBlock_left-white__s26lN`,
	"fold": `SelectPaymentBlock_fold__VI+Oi`,
	"ntrclose-button": `SelectPaymentBlock_ntrclose-button__cS3KZ`,
	"wrapper-invoice": `SelectPaymentBlock_wrapper-invoice__cnlfW`,
	"white-wrapper": `SelectPaymentBlock_white-wrapper__THbhU`,
	"main": `SelectPaymentBlock_main__yxp2n`,
	"addr": `SelectPaymentBlock_addr__7Fx3B`,
	"name": `SelectPaymentBlock_name__C7BV8`,
	"cust-number": `SelectPaymentBlock_cust-number__gkFL+`,
	"invoice-amount": `SelectPaymentBlock_invoice-amount__FHeSW`,
	"amount-title": `SelectPaymentBlock_amount-title__jLEQ9`,
	"amount": `SelectPaymentBlock_amount__Fc-1S`,
	"tg-ml-11": `SelectPaymentBlock_tg-ml-11__YFy4r`,
	"invoice-status": `SelectPaymentBlock_invoice-status__OST-P`,
	"invoice-status-paid": `SelectPaymentBlock_invoice-status-paid__ZFC3I`,
	"service": `SelectPaymentBlock_service__J7wMS`,
	"service-title": `SelectPaymentBlock_service-title__+frvN`,
	"service-date": `SelectPaymentBlock_service-date__60W-x`,
	"service-table-wrapper": `SelectPaymentBlock_service-table-wrapper__fBj2u`,
	"service-table": `SelectPaymentBlock_service-table__kctWv`,
	"view-invoice-ticket": `SelectPaymentBlock_view-invoice-ticket__YNaS+`,
	"view-pint-btn": `SelectPaymentBlock_view-pint-btn__pLt2v`,
	"print-invoice": `SelectPaymentBlock_print-invoice__KHHST`,
	"service-num": `SelectPaymentBlock_service-num__w+xcT`
};
export default ___CSS_LOADER_EXPORT___;
